export const version = "ethers/5.6.6";
//# sourceMappingURL=_version.js.map